import { html, css } from 'lit-element';
import { connect } from '../store/connect';
import { actions, selectors } from '../user/';
import { FormElementUser } from './form-element-user';
import { DETAIL_MODES } from './constants';

export class FormElementBulkUser extends FormElementUser {
    constructor() {
        super();
    }

    static get styles() {
        return [...super.styles];
    }

    static get properties() {
        return {
            apply: {
                type: Boolean,
            },
            summaryValue: {
                type: String,
            },
        };
    }
    updated(changedProps) {
        super.updated(changedProps);
        // from the perspective of the form element, the detail mode means show view controls vs show edit controls
        // so the apply allows us to switch that on or off
        if (changedProps.has('apply')) {
            this.detailMode = this.apply ? DETAIL_MODES.EDIT : DETAIL_MODES.VIEW;
        }
    }
    render() {
        return html`<div>
            ${this.renderApply()}
            <div>${this.renderByType()}${this.renderTooltip()} ${this.renderSummaryValue()}</div>
        </div>`;
    }

    renderApply() {
        const { apply } = this;
        return html`<tmn-checkbox
            label="Apply"
            .checked=${apply}
            @tmn-switch-change=${this.handleApplyChanged}>
        </tmn-checkbox> `;
    }

    renderSummaryValue() {
        const { apply, summaryValue } = this;
        if (apply && summaryValue) {
            return html`(${summaryValue})`;
        }
    }

    handleApplyChanged(e) {
        const { path } = this;
        this.actions.toggleBulkApplyForPath({ path });
    }
}

const mapStateToProps = (state, ownProps) => {
    const hasPassedValidationCheckSelector = selectors.userPassedValidationSelectorFactory(
        ownProps.path
    );

    const valueSelector = selectors.bulkUserElementValueFactory(
        ownProps.path,
        ownProps.itemTemplate
    );

    const summaryValueSelector = selectors.bulkUserElementSummaryValueFactory(
        ownProps.path,
        ownProps.itemTemplate
    );

    const isDirtySelector = selectors.userElementIsDirtyFactory(
        ownProps.path,
        ownProps.itemTemplate
    );

    const isReadOnlySelector = selectors.userElementIsReadOnlyFactory(
        ownProps.path,
        ownProps.itemTemplate
    );

    const bulkApplySelector = selectors.bulkUserElementApplyFactory(
        ownProps.path,
        ownProps.itemTemplate
    );

    const errorMessageSelector = selectors.userElementErrorFactory(ownProps.path);

    return (state) => {
        return {
            hasPassedValidationCheck: hasPassedValidationCheckSelector(state),
            value: valueSelector(state),
            summaryValue: summaryValueSelector(state),
            isDirty: isDirtySelector(state),
            apply: bulkApplySelector(state),
            isReadOnly: isReadOnlySelector(state),
            validationError: errorMessageSelector(state),
        };
    };
};

customElements.define(
    'form-element-bulk-user',
    connect(mapStateToProps, actions)(FormElementBulkUser)
);
